export enum EConsommableSurface {
    GeloseContact = 1,
    Bilame = 2,
    Ecouvillon = 3,
    Lingette = 4,
}